import React, { PureComponent } from 'react';
import {AlbumThumbnail} from '../../album-view/components/album-thumbnail';

export default class SnapfishAlbumView extends PureComponent {
    componentDidMount() {
        this.props.loadAdditionalAlbums();
    }

    render() {
        if(!this.props.isVisible) return <span/>;
            
        return (
            <div>
               
                <div
				className = "content-aware-container album-container snapfish-album"
				ref={thisContainer => (this.container = thisContainer)}
				>
				<div className="view-title-text">Albums</div>
				
                    {[...this.props.albums.values()].map(album => {
						return (
							<AlbumThumbnail
								key={`album.${album.id}`}
								id={album.id}
								title={album.title}
								thumbnails={album.thumbnails}
								linkPath={`/my/albums/${album.id}`}
								showMenu={this.showMenu}
								albumClicked={() => this.props.itemClick(album.id)} //Double check performance here
								selected={album.selected}
								selectMode={false}
								snapfishMode={true}
								stats={album.stats}

							/>
						);
					})}
</div>
                
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/snapfish/components/snapfish-album-view.jsx